<app-mu-modal-dialog-layout
  [title]="title"
  [subTitle]="subTitle"
  [subTitleValue]="subTitleValue"
  [icon]="'fa-star'"
  [flagList]="flagList"
  [showFlag]="showFlag"
  [actionFlag]="actionFlag"
  [loaderFlag]="loaderFlag"
  [formData]="formData"
  [showCloseIcon]="true"
  [buttonCancel]="true"
  [buttonMainActionLabel]="'page.delivery.orders.rate.send'"
>
  <div class="p-grid p-justify-center p-align-center" *ngIf="showModalState" modalDialogContent>
    <p class="p-col-12 mu-modal-text mu-without-padding" [innerHTML]="message || 'page.delivery.orders.rate.text' | translate"></p>
    <form class="p-col-12 mu-without-padding" [formGroup]="formData" appValidator>
      <div class="p-grid p-justify-center">
        <div class="p-col-12 mu-without-padding">
          <app-mu-rating [formData]="formData" [field]="valueField"></app-mu-rating>
        </div>
        <div class="p-field p-col-12 mu-modal-textarea mu-modal-rate-textarea">
          <textarea
            pInputTextarea
            [id]="descriptionField"
            [name]="descriptionField"
            [formControlName]="descriptionField"
            maxlength="300"
            [placeholder]="'page.delivery.orders.rate.' + descriptionField + 'PlaceHolder' | translate"
          ></textarea>
          <div class="error"></div>
        </div>
      </div>
    </form>
  </div>
</app-mu-modal-dialog-layout>
